module.exports = __webpack_public_path__ + "img/hover-question-gray.1c47d97c.svg";